// reducers.js
import { combineReducers } from 'redux'
import { appReducer } from './appReducer'

const createRootReducer = (history: any) =>
  combineReducers({
    app: appReducer,
  })
export default createRootReducer
